<template>
    <loading />
    <nav-header />
  <router-view />
</template>

<script setup>
  import { onMounted } from 'vue';
  import NavHeader from './components/NavHeader.vue';
  import Loading from './components/Loading.vue';
  // import './js/global.js';
  onMounted(() => {
    // document.cookie = "local=ar; path=/";
    /* var scriptTag = document.createElement("script");
      scriptTag.src = "https://cdn.jsdelivr.net/npm/axios/dist/axios.min.js";
      scriptTag.id = "axios";
      document.getElementsByTagName('head')[0].appendChild(scriptTag); */
  });
</script>

  <style>
  body {
    background-image: url("./assets/background/background4.jpg");
    background-size: cover;
  }

  body.admin-background {
    background-image: url("./assets/background/emp_background.jpg");
  }

  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #333;
  }

  nav {
    padding: 30px;
  }

  nav a {
    font-weight: bold;
    color: #2c3e50;
  }

  nav a.router-link-exact-active {
    color: #000;
    font-weight: bold;
  }

  .main-section {
    background-color: #ffffffb5;
    /* background-color: #2a225178; */
    padding-top: 2rem;
    padding-bottom: 3rem;
    border-radius: 10px;
    overflow: auto;
  }
  .main-section > * ,  .main-section .label{
    color: #fff;
    text-shadow: 1px 1px 3px #000;
  }
  .main-section > * > * {
    color: initial;
    text-shadow: none;
  }
</style>
